import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DetailSubsection } from '@periscopes/general';
import React from 'react';
import { SonarObjectStakeholders } from '@ui/general';
export const BusinessContextStakeholder = ({ sonarObjectId }) => React.createElement(DetailSubsection, { title: COPY_SPECIFIC.STAKEHOLDERS },
    React.createElement(SonarObjectStakeholders, { direction: 'horizontal', sonarObjectId: sonarObjectId, withLatest: true }));
